import { css, html } from "lit";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import "../Grid/index.js";
import "../GridCell/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfPageLayout = class extends BaseComponent {
  render() {
    return html`
      <slot name="menu"></slot>
      <div class="flex flex-auto flex-col overflow-hidden">
        <slot name="navbar"></slot>
        <slot name="content"></slot>
      </div>
    `;
  }
};
DsfPageLayout.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        display: flex;
        flex-direction: row;
        height: 100vh;
        width: 100vw;
      }

      ::slotted(*) {
        background-color: rgb(var(--dsf-color-neutral-0));
      }

      ::slotted([sticky]) {
        position: sticky;
        top: 0;
      }

      ::slotted([slot='menu']) {
        position: relative;
        flex: 0 0 auto;
        border-right: calc(0.1 * var(--dsf-base-size)) solid rgba(var(--dsf-color-neutral-100)) !important;
      }

      ::slotted([slot='navbar']) {
        position: relative;
        flex: 0 0 auto;
        border-bottom: calc(0.1 * var(--dsf-base-size)) solid rgba(var(--dsf-color-neutral-100)) !important;
      }

      ::slotted([slot='content']) {
        flex: 1 1 auto;
        overflow: auto;
      }
    `
];
DsfPageLayout.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfPageLayout = __decorateClass([
  defineElement("dsf-page-layout")
], DsfPageLayout);
export {
  DsfPageLayout
};
